import React from "react";
import { graphql } from "gatsby";
import { LayoutParser } from "@fishrmn/fishrmn-utils";
import { Hoo, Reviews, Location, ImageGallery, Call, ContactForm } from "@fishrmn/fishrmn-components";

import Layout from "../components/Layout";
import SectionLayouts from "../components/SectionLayouts";

import HomeBackground from "../data/liquor3.jpg";
import LocationBackground from "../data/liquor21.jpg";
import ContactBackground from "../data/liquor16.jpg";
import DrizlyLogo from "../data/drizly_logo.png";

export default ({ data, location }) => {
  const { siteContent } = data.allAirtable.edges[0].node;
  const images = siteContent.Images.filter(image => image.url).map(
    image => image.url
  );
  const pageData = {
    about: siteContent.About,
    address: siteContent.Business_Address,
    phone: siteContent.Business_Phone,
    hoo:
      siteContent.Hours_of_Operation.length > 1 &&
      siteContent.Hours_of_Operation,
    pageTitle: `Welcome to ${siteContent.Business_Name}`,
    pageTitleBackgroundColor: "#3d3d3d",
    businessName: siteContent.Business_Name,
    images: images.length > 0 && images,
    timezone: "America/New_York",
    reviews: siteContent.Reviews.map(review => ({
      content: review.text,
      source: review.data_source
    })).filter(review => review.source === "yelp" && review.content.length > 0),
  };
  const sectionLayouts = LayoutParser().parsePageLayout(
    [
      <div>
        <div id="home">
          <div style={{ backgroundImage: `url('${HomeBackground}')` }}>
            <div>
              <h1>{pageData.businessName.toUpperCase()}</h1>
              <Hoo hours={pageData.hoo} timezone={pageData.timezone} showHours={false} />
            </div>
          </div>
          <div>
            <h1>WELCOME</h1>
            <div>{pageData.about.slice(2, pageData.about.length-2)}</div>
            <a href="https://drizly.com/alcohol-delivery-in-washington-dc" target="_blank">
            <button id="drizly-button">
              <div>
                <h4>Order Online With Drizly</h4>
              </div>
              <div>
                <img src={DrizlyLogo} alt="Drizly Logo" />
              </div>
            </button>
            </a>
            <h1>REVIEWS</h1>
            <Reviews reviews={pageData.reviews}/>
          </div>
        </div>
        <div id="location">
          <div style={{ backgroundImage: `url('${LocationBackground}')` }}>
            <div>
              <h1>LOCATION</h1>
              <div>
                <div><Hoo hours={pageData.hoo} timezone={pageData.timezone} /></div>
                <div><Location address={pageData.address} afterText=""/></div>
              </div>
            </div>
          </div>
        </div>
        <div id="gallery">
          <h1>GALLERY</h1>
          <ImageGallery images={pageData.images} imagesPerRow={3} />
        </div>
        <div id="contact">
          <div style={{ backgroundImage: `url('${ContactBackground}')` }}>
            <div>
              <h1>CONTACT</h1>
              <Call number={pageData.phone} />
              <h1>REACH OUT</h1>
              <ContactForm subscriptionCallback={() => true} header="" showTextArea textAreaPlaceholder="Message"/>
            </div>
          </div>
        </div>
      </div>
    ],
    pageData
  );
  return (
    <Layout location={location}>
      <SectionLayouts sectionLayouts={sectionLayouts} />
    </Layout>
  );
};

export const query = graphql`
  query HomeQuery {
    allAirtable {
      edges {
        node {
          siteContent {
            Business_Address
            Business_Phone
            Hours_of_Operation
            Business_Name
            Images {
              url
            }
            About
            Reviews {
              text
              data_source
            }
          }
        }
      }
    }
  }
`;
